export enum PREFERRED_UNIT_VALUE {
  LBTC = 100000000,
  mBTC = 100000,
  uBTC = 100,
  SAT = 1,
}
